import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import WeeklyTracker from './WeeklyTracker';
import Login from './Login';
import EliForm from './EliForm';
import SelfTaskForm from './SelfTaskForm';

function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  const hash = window.location.hash.replace('#', '');
  const path = window.location.pathname;
  const isEli = hash.includes('eli') || path.includes('eli');
  const isAdd = hash.includes('add') || path.includes('add');

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => { setSession(session); setLoading(false); });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_, session) => setSession(session));
    return () => subscription.unsubscribe();
  }, []);

  if (isEli) return <EliForm />;
  if (isAdd) return <SelfTaskForm />;
  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#0f172a' }}><div style={{ width: 40, height: 40, border: '3px solid rgba(255,255,255,0.1)', borderTopColor: '#3b82f6', borderRadius: '50%', animation: 'spin 1s linear infinite' }} /><style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style></div>;
  return !session ? <Login /> : <WeeklyTracker session={session} />;
}

export default App;
